<template>
  <div class="wrapper">
    <div class="animated fadeIn">

      <b-row>
        <b-col sm="12">
          <b-card header-class="redmfu" >
            <div slot="header">
              <strong  v-if="thai_student==1">ตอนที่ 5 ความคิดเห็นและข้อเสนอแนะด้านหลักสูตร</strong>
              <strong v-else >Part 5 Recommendations for Curriculum and Internationalisation</strong>
              <div style="float:right;">
                <b-badge pill variant="warning" class="font-sm text-dark p-2 pr-3 pl-3">Session Timeout : {{ this.$store.state.timeExp }}</b-badge>
              </div>
            </div>
            <div v-for="item in items" v-bind:key="item.QUESTION_PK" v-if="item.QUESTION_PK !=49 && item.QUESTION_PK !=50">
              <b-form-group
                class="text-danger"
                v-if="(items2[item.QUESTION_PK-47].VALUES ==2)"
                :label="'*  ' +item.NUMBER  + ') '+item.QUESTION_NAME"
                label-for="basicInlineRadios"
                :label-cols="12"
              ></b-form-group>
              <b-form-group
                v-else
                :label="item.NUMBER  + ') '+item.QUESTION_NAME"
                label-for="basicInlineRadios"
                :label-cols="12"
              ></b-form-group>

              <b-form-group
                label-cols-sm="1"
                label
                label-align-sm="right"
                label-for="nested-street"
              >
                <b-form-radio-group
                  v-if="item.QUESTION_PK==47"
                  v-model="selected_47"
                  value-field="BYTECODE"
                  text-field="BYTEDES"
                  :options="items[0].ANS"
                  stacked
                  name="selected_47"
                >
                </b-form-radio-group>
                <b-form-radio-group
                  v-if="item.QUESTION_PK==48"
                  v-model="selected_48"
                  value-field="BYTECODE"
                  text-field="BYTEDES"
                  :options="items[1].ANS"
                  stacked
                  name="selected_48"
                >
                </b-form-radio-group>
<!--                <b-form-radio-group-->
<!--                  v-if="item.QUESTION_PK==49"-->
<!--                  v-model="selected_49"-->
<!--                  value-field="BYTECODE"-->
<!--                  text-field="BYTEDES"-->
<!--                  :options="items[2].ANS"-->
<!--                  stacked-->
<!--                  name="selected_49"-->
<!--                >-->
<!--                </b-form-radio-group>-->
<!--                <b-form-radio-group-->
<!--                  v-if="item.QUESTION_PK==50"-->
<!--                  v-model="selected_50"-->
<!--                  value-field="BYTECODE"-->
<!--                  text-field="BYTEDES"-->
<!--                  :options="items[3].ANS"-->
<!--                  stacked-->
<!--                  name="selected_50"-->
<!--                >-->
<!--                </b-form-radio-group>-->
                <b-form-radio-group
                  v-if="item.QUESTION_PK==51"
                  v-model="selected_51"
                  value-field="BYTECODE"
                  text-field="BYTEDES"
                  :options="items[4].ANS"
                  stacked
                  name="selected_51"
                >
                </b-form-radio-group>
                <b-form-radio-group
                  v-if="item.QUESTION_PK==52"
                  v-model="selected_52"
                  value-field="BYTECODE"
                  text-field="BYTEDES"
                  :options="items[5].ANS"
                  stacked
                  name="selected_52"
                >
                </b-form-radio-group>
                <b-form-radio-group
                  v-if="item.QUESTION_PK==53"
                  v-model="selected_53"
                  value-field="BYTECODE"
                  text-field="BYTEDES"
                  :options="items[6].ANS"
                  stacked
                  name="selected_53"
                >
                </b-form-radio-group>

<!--                <b-form-radio-group-->
<!--                  v-if="item.QUESTION_PK==54"-->
<!--                  v-model="selected_54"-->
<!--                  value-field="BYTECODE"-->
<!--                  text-field="BYTEDES"-->
<!--                  :options="items[7].ANS"-->
<!--                  stacked-->
<!--                  name="selected_54"-->
<!--                >-->
<!--                </b-form-radio-group>-->
<!--                  <b-form-radio-group-->
<!--                    v-if="item.QUESTION_PK==55"-->
<!--                    v-model="selected_55"-->
<!--                    value-field="BYTECODE"-->
<!--                    text-field="BYTEDES"-->
<!--                    :options="items[8].ANS"-->
<!--                    stacked-->
<!--                    name="selected_55"-->
<!--                  >-->
<!--                </b-form-radio-group>-->
                <b-form-checkbox-group
                  v-if="item.QUESTION_PK==54"
                  v-model="selected_addprogram"
                  value-field="BYTECODE"
                  text-field="BYTEDES"
                  :options="items[7].ANS"
                  stacked
                  name="selected_addprogram"
                >
<!--                  select:{{ selected_addprogram }}-->
                  <b-form-input
                    v-if="item.QUESTION_PK==54 "
                    id="qn_addprogram7_txt"
                    type="text"
                    autocomplete="qn_addprogram7_txt"
                    v-model="qn_addprogram7_txt"
                    placeholder="Other..."
                  ></b-form-input>
                </b-form-checkbox-group>

                <b-form-textarea
                  v-if="item.CONTROL_Q==1 && item.QUESTION_PK=='55' "
                  :rows="5"
                  id="current_comment_program"
                  type="text"
                  autocomplete="current_comment_program"
                  v-model="current_comment_program"
                  placeholder="Content.."
                ></b-form-textarea>
                <b-form-textarea
                  v-if="item.CONTROL_Q==1 && item.QUESTION_PK=='56' "
                  :rows="5"
                  id="current_comment_learn"
                  type="text"
                  autocomplete="current_comment_learn"
                  v-model="current_comment_learn"
                  placeholder="Content.."
                ></b-form-textarea>
                <b-form-textarea
                  v-if="item.CONTROL_Q==1 && item.QUESTION_PK=='57' "
                  :rows="5"
                  id="current_comment_activity"
                  type="text"
                  autocomplete="current_comment_activity"
                  v-model="current_comment_activity"
                  placeholder="Content.."
                ></b-form-textarea>
                <b-form-textarea
                  v-if="item.CONTROL_Q==1 && item.QUESTION_PK=='58' "
                  :rows="5"
                  id="current_comment_train"
                  type="text"
                  autocomplete="current_comment_train"
                  v-model="current_comment_train"
                  placeholder="Content.."
                ></b-form-textarea>

                <b-form-textarea
                  v-if="item.CONTROL_Q==1 && item.QUESTION_PK=='59' "
                  :rows="5"
                  id="current_comment_inter"
                  type="text"
                  autocomplete="current_comment_inter"
                  v-model="current_comment_inter"
                  placeholder="Content.."
                ></b-form-textarea>
                </b-form-group>
            </div>
            <div slot="footer" class="text-center">
              <b-button type="submit" size="md" class="mr-2" variant="success" @click="onBack">
                <i class="fa fa-arrow-circle-o-left"></i> Back
              </b-button>
              <b-button type="submit" size="md" class="mr-2" variant="primary" @click="onSubmit">
                <i class="fa fa-dot-circle-o"></i> Submit
              </b-button>

              <b-button type="reset" size="md" class="mr-2" variant="danger" @click="onReset">
                <i class="fa fa-ban"></i> Reset
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <!-- <div slot="footer" class="text-center">
        <b-button type="submit" size="sm" variant="primary" @click="onSubmit">
          <i class="fa fa-dot-circle-o"></i> Submit
        </b-button>

        <b-button type="reset" size="sm" variant="danger"  @click="onReset">
          <i class="fa fa-ban"></i> Reset
        </b-button>
      </div> -->
<!--      </b-col>-->
<!--      </b-row>-->
      <b-row>
        <b-col lg="6"></b-col>
      </b-row>
    </div>

    <b-modal v-if="thai_student==1"
             title="คุณกรอกข้อมูลไม่ครบถ้วน"
             class="modal-danger"
             v-model="dangerModal"
             @ok="dangerModal = false"
             ok-variant="danger"
    >{{ current_erorrtxt }}
    </b-modal>
    <b-modal v-if="thai_student==0"
             title="You didn’t fill your information completely"
             class="modal-danger"
             v-model="dangerModal"
             @ok="dangerModal = false"
             ok-variant="danger"
    >{{ current_erorrtxt }}
    </b-modal>
  </div>
</template>

<script>
import YimoVueEditor from "../../../node_modules/yimo-vue-editor/src/Editor.vue";
import api from "../../service/api";

export default {
  components: {YimoVueEditor},
  name: "CreateGeneral",
  data() {
    return {
      number:0,
      std_id: "",
      student: {},
      sex: "",
      current_erorrtxt: "",
      items: [],
      items2: [],
      useritems: [],
      selected_addprogram: "",
      qn_addprogram7_txt: "",
      current_comment_program: "",
      current_comment_learn: "",
      current_comment_activity: "",
      current_comment_train:"",
      current_comment_inter:"",
      selected_47:"",
      selected_48:"",
      selected_49:"",
      selected_50:"",
      selected_51:"",
      selected_52:"",
      selected_53:"",
      // selected_54:"",
      // selected_55:"",
      selected_addprogram_1: "",
      selected_addprogram_2: "",
      selected_addprogram_3: "",
      selected_addprogram_4: "",
      selected_addprogram_5: "",
      selected_addprogram_6: "",
      selected_addprogram_7: "",
      selected_addprogram_8: "",
      selected_addprogram_9: "",
      back_number:"",
      dangerModal: false,
      actionUpdate: 10,
      actionUpdateRegis: 10,
    };
  },

  methods: {
    onBack(){
      var number;
      // console.log("n==",number)
      number=parseInt(this.$route.query.x)-5 ;
      this.$router.push("/part4?x=" + number);
    },
    getCurrentStudent(studentid) {
      api
        .getStudentGeneral(studentid)
        .then(res => {
          var currentSt = res.data.data[0];
          // console.log("res==",res.data.data[0]);
          if (res.data.data.length > 0) {
            this.actionUpdate = 1;
            this.std_id = this.student.STUDENTID;
            this.selected_47=currentSt.QN_47;
            this.selected_48=currentSt.QN_48;
            this.selected_49=currentSt.QN_49;
            this.selected_50=currentSt.QN_50;
            this.selected_51=currentSt.QN_51;
            this.selected_52=currentSt.QN_52;
            this.selected_53=currentSt.QN_53;

            var selectedData = [];
            var j = -1;
            if (currentSt.QN_ADDPROGRAM1 != null) {
              j = j + 1;
              selectedData[j] = 1;
            }
            if (currentSt.QN_ADDPROGRAM2 != null) {
              j = j + 1;
              selectedData[j] = 2;
            }
            if (currentSt.QN_ADDPROGRAM3 != null) {
              j = j + 1;
              selectedData[j] = 3;
            }
            if (currentSt.QN_ADDPROGRAM4 != null) {
              j = j + 1;
              selectedData[j] = 4;
            }
            if (currentSt.QN_ADDPROGRAM5 != null) {
              j = j + 1;
              selectedData[j] = 5;
            }
            if (currentSt.QN_ADDPROGRAM6 != null) {
              j = j + 1;
              selectedData[j] = 6;
            }
            if (currentSt.QN_ADDPROGRAM7 != null) {
              j = j + 1;
              selectedData[j] = 7;

            }
            if (currentSt.QN_ADDPROGRAM8 != null) {
              j = j + 1;
              selectedData[j] = 8;
            }
            if (currentSt.QN_ADDPROGRAM9 != null) {
              j = j + 1;
              selectedData[j] = 9;
            }
            // console.log(selectedData);
            this.selected_addprogram = selectedData;
            this.qn_addprogram7_txt = currentSt.QN_ADDPROGRAM7_TXT;
            this.current_comment_program = currentSt.QN_COMMENT_PROGRAM;
            this.current_comment_learn = currentSt.QN_COMMENT_LEARN;
            this.current_comment_activity = currentSt.QN_COMMENT_ACTIVITY;
            this.current_comment_train=currentSt.QN_COMMENT_TRAIN;
            this.current_comment_inter=currentSt.QN_COMMENT_INTERNATIONALSATION;
          } else {
            this.actionUpdate = 0;
          }
        })
        .catch(err => {
          console.log("getCurrentStudent", err.toString());
          this.actionUpdate = 10
          this.$router.push("Logout");
        });
    },

    setStudent: function () {
      var student={};
      student.qn_year= this.$store.state.user.year;
      student.questionnaire_1 = 1;
      student.std_id = this.$store.state.user.studentid;
      student.selected_47=this.selected_47;
      if ((this.selected_47 == null) || (this.selected_47 == '')) {
        this.items2[0].VALUES = 2;
      } else {
        this.items2[0].VALUES = 1;
      }
      student.selected_48=this.selected_48;
      if ((this.selected_48 == null) || (this.selected_48 == '')) {
        this.items2[1].VALUES = 2;
      } else {
        this.items2[1].VALUES = 1;
      }
      this.selected_49='';
      this.selected_50='';
    /*  student.selected_49=this.selected_49;
      if ((this.selected_49 == null) || (this.selected_49 == '')) {
        this.items2[2].VALUES = 2;
      } else {
        this.items2[2].VALUES = 1;
      }
      student.selected_50=this.selected_50;
      if ((this.selected_50 == null) || (this.selected_50 == '')) {
        this.items2[3].VALUES = 2;
      } else {
        this.items2[3].VALUES = 1;
      }*/
      student.selected_51=this.selected_51;
      if ((this.selected_51 == null) || (this.selected_51 == '')) {
        this.items2[4].VALUES = 2;
      } else {
        this.items2[4].VALUES = 1;
      }
      student.selected_52=this.selected_52;
      if ((this.selected_52 == null) || (this.selected_52 == '')) {
        this.items2[5].VALUES = 2;
      } else {
        this.items2[5].VALUES = 1;
      }
      student.selected_53=this.selected_53;
      if ((this.selected_53 == null) || (this.selected_53 == '')) {
        this.items2[6].VALUES = 2;
      } else {
        this.items2[6].VALUES = 1;
      }
      // student.selected_54=this.selected_54;
      // if ((this.selected_54 == null) || (this.selected_54 == '')) {
      //   this.items2[7].VALUES = 2;
      // } else {
      //   this.items2[7].VALUES = 1;
      // }
      // student.selected_55=this.selected_55;
      // if ((this.selected_55 == null) || (this.selected_55 == '')) {
      //   this.items2[8].VALUES = 2;
      // } else {
      //   this.items2[8].VALUES = 1;
      // }
      student.selected_addprogram = this.selected_addprogram;
      student.selected_addprogram_1 = "";
      this.selected_addprogram_1 = "";
      student.selected_addprogram_2 = "";
      this.selected_addprogram_2 = "";
      student.selected_addprogram_3 = "";
      this.selected_addprogram_3 = "";
      student.selected_addprogram_4 = "";
      this.selected_addprogram_4 = "";
      student.selected_addprogram_5 = "";
      this.selected_addprogram_5 = "";
      student.selected_addprogram_6 = "";
      this.selected_addprogram_6 = "";
      student.selected_addprogram_7 = "";
      this.selected_addprogram_7 = "";
      student.qn_addprogram7_txt = "";
      // this.qn_addprogram7_txt = "";
      student.selected_addprogram_8 = "";
      this.selected_addprogram_8 = "";
      student.selected_addprogram_9 = "";
      this.selected_addprogram_9 = "";
      // console.log("selected_addprogram==", this.selected_addprogram);
      for (var i = 0; i < this.selected_addprogram.length; i++) {

        var ans_addprogram = this.selected_addprogram[i];

        if (ans_addprogram == "1") {
          student.selected_addprogram_1 = 1;
          this.selected_addprogram_1 = 1;
        } else if (ans_addprogram == "2") {
          student.selected_addprogram_2 = 1;
          this.selected_addprogram_2 = 1;
        } else if (ans_addprogram == "3") {
          student.selected_addprogram_3 = 1;
          this.selected_addprogram_3 = 1;
        } else if (ans_addprogram == "4") {
          student.selected_addprogram_4 = 1;
          this.selected_addprogram_4 = 1;
        } else if (ans_addprogram == "5") {
          student.selected_addprogram_5 = 1;
          this.selected_addprogram_5 = 1;
        } else if (ans_addprogram == "6") {
          student.selected_addprogram_6 = 1;
          this.selected_addprogram_6 = 1;
        } else if (ans_addprogram == "7") {
          student.selected_addprogram_7 = 1;
          this.selected_addprogram_7 = 1;
          student.qn_addprogram7_txt = this.qn_addprogram7_txt
          //.replaceAll( "'", "`");
        } else if (ans_addprogram == "8") {
          student.selected_addprogram_8 = 1;
          this.selected_addprogram_8 = 1;
        } else if (ans_addprogram == "9") {
          student.selected_addprogram_9 = 1;
          this.selected_addprogram_9 = 1;
        }
      }
      if (this.selected_addprogram.length >0)
      {
        this.items2[7].VALUES = 1;
      }else{
        this.items2[7].VALUES = 2;
      }
      if (this.current_comment_program == null) {
        this.current_comment_program = "";
      }
      if (this.current_comment_learn == null) {
        this.current_comment_learn = "";
      }
      if (this.current_comment_activity == null) {
        this.current_comment_activity = "";
      }
      if (this.current_comment_train == null) {
        this.current_comment_train = "";
      }
      if (this.current_comment_inter == null) {
        this.current_comment_inter = "";
      }
      student.current_comment_program = this.current_comment_program
      //.replaceAll( "'", "`");
      student.current_comment_learn = this.current_comment_learn
      //.replaceAll( "'", "`");
      student.current_comment_activity = this.current_comment_activity
      //.replaceAll( "'", "`");
      student.current_comment_train=this.current_comment_train
      //.replaceAll( "'", "`");
      student.current_comment_inter=this.current_comment_inter
      //.replaceAll( "'", "`");
      // console.log("Setstudent==", this.student);
      return student;
    },
    checkQuotation(s) {
      var quotation1 = "'";
      var quotation2 = "`";
      if (s.qn_addprogram7_txt != '' && s.qn_addprogram7_txt != null && s.qn_addprogram7_txt != undefined) {
        if (s.qn_addprogram7_txt.toString().length > 0) {
          if (s.qn_addprogram7_txt.toString().includes(quotation1)) {
            s.qn_addprogram7_txt = s.qn_addprogram7_txt.replaceAll(quotation1, "''");
          }
          if (s.qn_addprogram7_txt.toString().includes(quotation2)) {
            s.qn_addprogram7_txt = s.qn_addprogram7_txt.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.current_comment_program != '' && s.current_comment_program != null && s.current_comment_program != undefined) {
        if (s.current_comment_program.toString().length > 0) {
          if (s.current_comment_program.toString().includes(quotation1)) {
            s.current_comment_program = s.current_comment_program.replaceAll(quotation1, "''");
          }
          if (s.current_comment_program.toString().includes(quotation2)) {
            s.current_comment_program = s.current_comment_program.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.current_comment_learn != '' && s.current_comment_learn != null && s.current_comment_learn != undefined) {
        if (s.current_comment_learn.toString().length > 0) {
          if (s.current_comment_learn.toString().includes(quotation1)) {
            s.current_comment_learn = s.current_comment_learn.replaceAll(quotation1, "''");
          }
          if (s.current_comment_learn.toString().includes(quotation2)) {
            s.current_comment_learn = s.current_comment_learn.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.current_comment_activity != '' && s.current_comment_activity != null && s.current_comment_activity != undefined) {
        if (s.current_comment_activity.toString().length > 0) {
          if (s.current_comment_activity.toString().includes(quotation1)) {
            s.current_comment_activity = s.current_comment_activity.replaceAll(quotation1, "''");
          }
          if (s.current_comment_activity.toString().includes(quotation2)) {
            s.current_comment_activity = s.current_comment_activity.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.current_comment_train != '' && s.current_comment_train != null && s.current_comment_train != undefined) {
        if (s.current_comment_train.toString().length > 0) {
          if (s.current_comment_train.toString().includes(quotation1)) {
            s.current_comment_train = s.current_comment_train.replaceAll(quotation1, "''");
          }
          if (s.current_comment_train.toString().includes(quotation2)) {
            s.current_comment_train = s.current_comment_train.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.current_comment_inter != '' && s.current_comment_inter != null && s.current_comment_inter != undefined) {
        if (s.current_comment_inter.toString().length > 0) {
          if (s.current_comment_inter.toString().includes(quotation1)) {
            s.current_comment_inter = s.current_comment_inter.replaceAll(quotation1, "''");
          }
          if (s.current_comment_inter.toString().includes(quotation2)) {
            s.current_comment_inter = s.current_comment_inter.replaceAll(quotation2, "''");
          }
        }
      }
      return s;
    },
    getErrorTxt: function (s) {
      this.current_erorrtxt = "";
      this.numEror = 0;
      var substring = "--";
      var substring55 = "55";
      var student  =this.checkQuotation(s);
      if ((this.selected_47=="") || (this.selected_47==null) || (this.selected_47=="None") || (this.selected_47==undefined) )
      {
        this.numEror = this.numEror + 1;
        this.items2[0].VALUES = 2;
        this.current_erorrtxt =this.thai_student == "1" ? this.current_erorrtxt + "/ระดับ": this.current_erorrtxt + "/level";
      }
      if ((this.selected_48=="") || (this.selected_48==null) || (this.selected_48=="None") || (this.selected_48==undefined) )
      {
        this.numEror = this.numEror + 1;
        this.items2[1].VALUES = 2;
        this.current_erorrtxt =this.thai_student == "1" ? this.current_erorrtxt + "/ระดับ": this.current_erorrtxt + "/level";
      }
    /*  if ((this.selected_49=="") || (this.selected_49==null) || (this.selected_49=="None") || (this.selected_49==undefined) )
      {
        this.numEror = this.numEror + 1;
        this.items2[2].VALUES = 2;
        this.current_erorrtxt =this.thai_student == "1" ? this.current_erorrtxt + "/ระดับ": this.current_erorrtxt + "/level";
      }
      if ((this.selected_50=="") || (this.selected_50==null) || (this.selected_50=="None") || (this.selected_50==undefined) )
      {
        this.numEror = this.numEror + 1;
        this.items2[3].VALUES = 2;
        this.current_erorrtxt =this.thai_student == "1" ? this.current_erorrtxt + "/ระดับ": this.current_erorrtxt + "/level";
      }*/
      if ((this.selected_51=="") || (this.selected_51==null) || (this.selected_51=="None") || (this.selected_51==undefined) )
      {
        this.numEror = this.numEror + 1;
        this.items2[4].VALUES = 2;
        this.current_erorrtxt =this.thai_student == "1" ? this.current_erorrtxt + "/ระดับ": this.current_erorrtxt + "/level";
      }
      if ((this.selected_52=="") || (this.selected_52==null) || (this.selected_52=="None") || (this.selected_52==undefined) )
      {
        this.numEror = this.numEror + 1;
        this.items2[5].VALUES = 2;
        this.current_erorrtxt =this.thai_student == "1" ? this.current_erorrtxt + "/ระดับ": this.current_erorrtxt + "/level";
      }
      if ((this.selected_53=="") || (this.selected_53==null) || (this.selected_53=="None") || (this.selected_53==undefined) )
      {
        this.numEror = this.numEror + 1;
        this.items2[6].VALUES = 2;
        this.current_erorrtxt =this.thai_student == "1" ? this.current_erorrtxt + "/ระดับ": this.current_erorrtxt + "/level";
      }

      // if ((this.selected_54=="") || (this.selected_54==null) || (this.selected_54=="None") || (this.selected_54==undefined) )
      // {
      //   this.numEror = this.numEror + 1;
      //   this.items2[7].VALUES = 2;
      //   this.current_erorrtxt =this.thai_student == "1" ? this.current_erorrtxt + "/ระดับ": this.current_erorrtxt + "/level";
      // }
      //
      // if ((this.selected_55=="") || (this.selected_55==null) || (this.selected_55=="None") || (this.selected_55==undefined) )
      // {
      //   this.numEror = this.numEror + 1;
      //   this.items2[8].VALUES = 2;
      //   this.current_erorrtxt =this.thai_student == "1" ? this.current_erorrtxt + "/ระดับ": this.current_erorrtxt + "/level";
      // }

    /*  if (this.selected_addprogram == null || this.selected_addprogram == "") {
        this.numEror = this.numEror + 1;
        this.items2[7].VALUES = 2;
        this.current_erorrtxt =
          this.thai_student == "1"
            ? this.current_erorrtxt + "/เพิ่มรายวิชา"
            : this.current_erorrtxt + "/Add Program";
      }*/
      // console.log("selected_addprogram_7==", this.selected_addprogram_7);
      // console.log("qn_addprogram7_txt==", this.qn_addprogram7_txt);

      if (this.selected_addprogram_1+this.selected_addprogram_2+this.selected_addprogram_3+this.selected_addprogram_4+this.selected_addprogram_5+this.selected_addprogram_6+this.selected_addprogram_7+this.selected_addprogram_8+this.selected_addprogram_9==0){
        this.numEror = this.numEror + 1;
        this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ตอบได้มากกว่า 1 ข้อ" : this.current_erorrtxt + "/You can choose more than one answer";
      }


      if ((this.selected_addprogram_7 == 1) && ((this.qn_addprogram7_txt == "") || (this.qn_addprogram7_txt == "None") || (this.qn_addprogram7_txt == null) || (this.qn_addprogram7_txt == "-"))) {
        this.numEror = this.numEror + 1;
        this.items2[7].VALUES = 2;
        this.current_erorrtxt =
          this.thai_student == "1"
            ? this.current_erorrtxt + "/อื่นๆ ระบุ"
            : this.current_erorrtxt + "/Other";
      } else if ((this.selected_addprogram_7 == 1) && (this.qn_addprogram7_txt != "")) {
        if (this.qn_addprogram7_txt.includes(substring)) {
          this.numEror = this.numEror + 1;
          this.items2[7].VALUES = 2;
          this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/อื่นๆ ระบุ --" : this.current_erorrtxt + "/Other --";
        }
        if (this.qn_addprogram7_txt.includes(substring55)) {
          this.numEror = this.numEror + 1;
          this.items2[7].VALUES = 2;
          this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/อื่นๆ ระบุ 55" : this.current_erorrtxt + "/Other 55";
        }
      }
      if (this.numEror == 0) {
        this.dangerModal = false;
      } else {
        this.dangerModal = true;
      }
      student.num_error= this.numEror;
      return student;
    },
    getQuestion: function (section, sex, thaistudent) {
      api
        .getQuestionBySection(section, sex, thaistudent)
        .then(res => {
          // console.log("section==",section)
          // console.log("sex==",sex)
          // console.log("thaistudent==",thaistudent)
          // console.log("คำถาม==",res)
          var number;
          number=parseInt(this.$route.query.x);
          // console.log("number==",number)
          // console.log("xx==",res.data.data.length)
          for (var i = 0; i < res.data.data.length; i++) {
            number= number + 1;
            res.data.data[i].NUMBER=number;
          }
          this.items = res.data.data;
          // console.log(this.items);
        })
        .catch(err => {
          console.log("2 getQuestionBySection", err.toString());
        });
    },
    getStudentQuestion() {
      this.std_id = this.$store.state.user.studentid;
      this.stdstudentId = this.$store.state.user.studentid;
      this.thai_student = this.$store.state.user.thaistudent;
      this.sex = this.$store.state.user.sex;
      this.getQuestion(5, this.sex, this.thai_student);

    },
    nextPart() {
      // if( this.actionUpdate == false){
      //     this.$router.push("/General");
      //   }else{
      this.$router.push("/employment");
      // }
    },
    updatePart5(student) {
      api
        .updateStudentPart5(student)
        .then(res => {
          // console.log(res);
          this.message = res.message;
          if (res.data.code == 200) {
            this.nextPart();
          }else{

          }
        })
        .catch(err => {
          console.log("updatePart5 error", err.toString());
        });
    },
    onCreateData(student) {
     // console.log("student==", this.student);
      api
        .postStudentUserQuestion(student)
        .then(res => {
          // console.log(res);
          this.message = res.message;
          // console.log("insert ผ่าน", this.studentId);
          // this.nextPart();
        })
        .catch(err => {
          console.log("postStudentUserQuestion");
          console.log("onCreateData error", err.toString());
        });

    },

    onUpdateData(student) {
      api
        .updateStudentUserQuestion(student)
        .then(res => {
          // console.log(res);
          this.message = res.message;
          // console.log("update ผ่าน", this.studentId);
          this.nextPart();
        })
        .catch(err => {
          console.log("onUpdateData error", err.toString());
        })

    },
    onReset() {
      this.selected_47="";
      this.selected_48="";
      this.selected_49="";
      this.selected_50="";
      this.selected_51="";
      this.selected_52="";
      this.selected_53="";
      this.selected_54="";
      this.selected_55="";

      this.selected_addprogram = "";
      this.selected_addprogram_1 = "";
      this.selected_addprogram_2 = "";
      this.selected_addprogram_3 = "";
      this.selected_addprogram_4 = "";
      this.selected_addprogram_5 = "";
      this.selected_addprogram_6 = "";
      this.selected_addprogram_7 = "";
      this.selected_addprogram_8 = "";
      this.selected_addprogram_9 = "";
      this.qn_addprogram7_txt = "";
      this.current_comment_learn = "";
      this.current_comment_program = "";
      this.current_comment_activity = "";
      this.current_comment_train="";


    },
    onSubmit() {
      var student={};
      student=this.setStudent();
      var s = this.getErrorTxt(student);
      if (s.num_error == 0) {
        if (this.actionUpdate == 0) {
          this.$router.push("/general");
        } else {
          this.updatePart5(s);
          // console.log("404actionUpdateRegis==",this.actionUpdateRegis);
          if (this.actionUpdateRegis == 0) {
            // console.log(" new regis");
            this.onCreateData(s);
          } else  if (this.actionUpdateRegis == 1){ // มี regis แล้้ว
            // console.log("update regis");
            this.onUpdateData(s);
          }else{
            console.log("error");
          }
        }
      }
    },
    getCurrentUserQuestion(studentid) {
      api
        .getStudentUserQuestionById(studentid)
        .then(res => {
          if (res.data.data.length > 0) {
            this.actionUpdateRegis = 1;
          } else {
            this.actionUpdateRegis = 0;
          }
          return this.actionUpdateRegis;
        })
        .catch(err => {
          this.actionUpdate = 10;
          console.log("getStudentUserQuestionById error", err.toString());
        })

    }
  },
  mounted() {
  },
  created() {
    for (var j = 47; j <= 59 ; j++) { //13 ข้อ
      var b = {ID: j, UPDATEDATA: 0, VALUES: 0}
      this.items2.push(b);
    }
    // console.log("items2=",this.items2)
    if (this.$store.state.token == null || this.$store.state.user == null) {
      this.$router.push("/logout");
    } else {
      // this.$router.push("/Dashboard");
    }
    this.std_id = this.$store.state.user.studentid;
    api.onSetHeader();
    this.actionUpdate = this.getCurrentStudent(this.std_id);
    this.getStudentQuestion();
    this.actionUpdateRegis= this.getCurrentUserQuestion(this.std_id);

  }
};
</script>
<style>
</style>
